import { Component } from '@angular/core';


export class ErrorComponent {}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/error/error.component.ts